// src/constants/AcupointConstants.ts

export interface AcupointSerializer {
  acupointId: number
  acupointCode: string
  acupointName: string
  acupointPartNo: number
  countsPrivate?: number
}

export class AcupointConstants {
  /** 서버에서 받아온 경혈 데이터 (우선순위가 높음) */
  private static serverAcupoints: AcupointSerializer[] | null = null

  /** (1, 'BL001', '정명', 1) 형태의 원본 튜플 배열 (기본값) */
  static readonly rawData: [number, string, string, number][] = [
    [1, "BL001", "정명", 1],
    [2, "BL002", "찬죽", 1],
    [3, "BL003", "미충", 1],
    [4, "BL004", "곡차", 1],
    [5, "BL005", "오처", 1],
    [6, "BL006", "승광", 1],
    [7, "BL007", "통천", 1],
    [8, "BL008", "낙각", 1],
    [9, "BL009", "옥침", 1],
    [10, "BL010", "천주", 1],
    [11, "BL011", "대저", 3],
    [12, "BL012", "풍문", 3],
    [13, "BL013", "폐수", 3],
    [14, "BL014", "궐음수", 3],
    [15, "BL015", "심수", 3],
    [16, "BL016", "독수", 3],
    [17, "BL017", "격수", 3],
    [18, "BL018", "간수", 3],
    [19, "BL019", "담수", 3],
    [20, "BL020", "비수", 3],
    [21, "BL021", "위수", 3],
    [22, "BL022", "삼초수", 3],
    [23, "BL023", "신수", 3],
    [24, "BL024", "기해수", 3],
    [25, "BL025", "대장수", 3],
    [26, "BL026", "관원수", 3],
    [27, "BL027", "소장수", 3],
    [28, "BL028", "방광수", 3],
    [29, "BL029", "중려수", 3],
    [30, "BL030", "백환수", 3],
    [31, "BL031", "상료", 3],
    [32, "BL032", "차료", 3],
    [33, "BL033", "중료", 3],
    [34, "BL034", "하료", 3],
    [35, "BL035", "회양", 3],
    [36, "BL036", "승부", 5],
    [37, "BL037", "은문", 5],
    [38, "BL038", "부극", 5],
    [39, "BL039", "위양", 5],
    [40, "BL040", "위중", 5],
    [41, "BL041", "부분", 3],
    [42, "BL042", "백호", 3],
    [43, "BL043", "고황", 3],
    [44, "BL044", "신당", 3],
    [45, "BL045", "의희", 3],
    [46, "BL046", "격관", 3],
    [47, "BL047", "혼문", 3],
    [48, "BL048", "양강", 3],
    [49, "BL049", "의사", 3],
    [50, "BL050", "위창", 3],
    [51, "BL051", "황문", 3],
    [52, "BL052", "지실", 3],
    [53, "BL053", "포황", 3],
    [54, "BL054", "질변", 3],
    [55, "BL055", "합양", 5],
    [56, "BL056", "승근", 5],
    [57, "BL057", "승산", 5],
    [58, "BL058", "비양", 5],
    [59, "BL059", "부양", 5],
    [60, "BL060", "곤륜", 5],
    [61, "BL061", "복삼", 5],
    [62, "BL062", "신맥", 5],
    [63, "BL063", "금문", 5],
    [64, "BL064", "경골", 5],
    [65, "BL065", "속골", 5],
    [66, "BL066", "족통곡", 5],
    [67, "BL067", "지음", 5],
    [68, "CV001", "회음", 2],
    [69, "CV002", "곡골", 2],
    [70, "CV003", "중극", 2],
    [71, "CV004", "관원", 2],
    [72, "CV005", "석문", 2],
    [73, "CV006", "기해", 2],
    [74, "CV007", "음교", 2],
    [75, "CV008", "신궐", 2],
    [76, "CV009", "수분", 2],
    [77, "CV010", "하완", 2],
    [78, "CV011", "건리", 2],
    [79, "CV012", "중완", 2],
    [80, "CV013", "상완", 2],
    [81, "CV014", "거궐", 2],
    [82, "CV015", "구미", 2],
    [83, "CV016", "중정", 2],
    [84, "CV017", "단중", 2],
    [85, "CV018", "옥당", 2],
    [86, "CV019", "자궁", 2],
    [87, "CV020", "화개", 2],
    [88, "CV021", "선기", 2],
    [89, "CV022", "천돌", 2],
    [90, "CV023", "염천", 1],
    [91, "CV024", "승장", 1],
    [92, "GB001", "동자료", 1],
    [93, "GB002", "청회", 1],
    [94, "GB003", "상관", 1],
    [95, "GB004", "함염", 1],
    [96, "GB005", "현로", 1],
    [97, "GB006", "현리", 1],
    [98, "GB007", "곡빈", 1],
    [99, "GB008", "솔곡", 1],
    [100, "GB009", "천충", 1],
    [101, "GB010", "부백", 1],
    [102, "GB011", "두규음", 1],
    [103, "GB012", "완골", 1],
    [104, "GB013", "본신", 1],
    [105, "GB014", "양백", 1],
    [106, "GB015", "두임읍", 1],
    [107, "GB016", "목창", 1],
    [108, "GB017", "정영", 1],
    [109, "GB018", "승영", 1],
    [110, "GB019", "뇌공", 1],
    [111, "GB020", "풍지", 1],
    [112, "GB021", "견정", 4],
    [113, "GB022", "연액", 2],
    [114, "GB023", "첩근", 2],
    [115, "GB024", "일월", 2],
    [116, "GB025", "경문", 2],
    [117, "GB026", "대맥", 2],
    [118, "GB027", "오추", 2],
    [119, "GB028", "유도", 2],
    [120, "GB029", "거료", 5],
    [121, "GB030", "환도", 5],
    [122, "GB031", "풍시", 5],
    [123, "GB032", "중독", 5],
    [124, "GB033", "족양관", 5],
    [125, "GB034", "양릉천", 5],
    [126, "GB035", "양교", 5],
    [127, "GB036", "외구", 5],
    [128, "GB037", "광명", 5],
    [129, "GB038", "양보", 5],
    [130, "GB039", "현종", 5],
    [131, "GB040", "구허", 5],
    [132, "GB041", "족임읍", 5],
    [133, "GB042", "지오회", 5],
    [134, "GB043", "협계", 5],
    [135, "GB044", "족규음", 5],
    [136, "GV001", "장강", 3],
    [137, "GV002", "요수", 3],
    [138, "GV003", "요양관", 3],
    [139, "GV004", "명문", 3],
    [140, "GV005", "현추", 3],
    [141, "GV006", "척중", 3],
    [142, "GV007", "중추", 3],
    [143, "GV008", "근축", 3],
    [144, "GV009", "지양", 3],
    [145, "GV010", "영대", 3],
    [146, "GV011", "신도", 3],
    [147, "GV012", "신주", 3],
    [148, "GV013", "도도", 3],
    [149, "GV014", "대추", 3],
    [150, "GV015", "아문", 1],
    [151, "GV016", "풍부", 1],
    [152, "GV017", "뇌호", 1],
    [153, "GV018", "강간", 1],
    [154, "GV019", "후정", 1],
    [155, "GV020", "백회", 1],
    [156, "GV021", "전정", 1],
    [157, "GV022", "신회", 1],
    [158, "GV023", "상성", 1],
    [159, "GV024", "신정", 1],
    [160, "GV025", "소료", 1],
    [161, "GV026", "수구", 1],
    [162, "GV027", "태단", 1],
    [163, "GV028", "은교", 1],
    [164, "HN001", "인당", 1],
    [165, "HN041", "어요", 1],
    [166, "HN160", "내영향", 1],
    [167, "HT001", "극천", 4],
    [168, "HT002", "청령", 4],
    [169, "HT003", "소해", 4],
    [170, "HT004", "영도", 4],
    [171, "HT005", "통리", 4],
    [172, "HT006", "음극", 4],
    [173, "HT007", "신문", 4],
    [174, "HT008", "소부", 4],
    [175, "HT009", "소충", 4],
    [176, "KI001", "용천", 5],
    [177, "KI002", "연곡", 5],
    [178, "KI003", "태계", 5],
    [179, "KI004", "대종", 5],
    [180, "KI005", "수천", 5],
    [181, "KI006", "조해", 5],
    [182, "KI007", "부류", 5],
    [183, "KI008", "교신", 5],
    [184, "KI009", "축빈", 5],
    [185, "KI010", "음곡", 5],
    [186, "KI011", "횡골", 2],
    [187, "KI012", "대혁", 2],
    [188, "KI013", "기혈", 2],
    [189, "KI014", "사만", 2],
    [190, "KI015", "중주", 2],
    [191, "KI016", "황수", 2],
    [192, "KI017", "상곡", 2],
    [193, "KI018", "석관", 2],
    [194, "KI019", "음도", 2],
    [195, "KI020", "복통곡", 2],
    [196, "KI021", "유문", 2],
    [197, "KI022", "보랑", 2],
    [198, "KI023", "신봉", 2],
    [199, "KI024", "영허", 2],
    [200, "KI025", "신장", 2],
    [201, "KI026", "욱중", 2],
    [202, "KI027", "수부", 2],
    [203, "LI001", "상양", 4],
    [204, "LI002", "이간", 4],
    [205, "LI003", "삼간", 4],
    [206, "LI004", "합곡", 4],
    [207, "LI005", "양계", 4],
    [208, "LI006", "편력", 4],
    [209, "LI007", "온유", 4],
    [210, "LI008", "하렴", 4],
    [211, "LI009", "상렴", 4],
    [212, "LI010", "수삼리", 4],
    [213, "LI011", "곡지", 4],
    [214, "LI012", "주료", 4],
    [215, "LI013", "수오리", 4],
    [216, "LI014", "비노", 4],
    [217, "LI015", "견우", 4],
    [218, "LI016", "거골", 4],
    [219, "LI017", "천정", 1],
    [220, "LI018", "부돌", 1],
    [221, "LI019", "화료", 1],
    [222, "LI020", "영향", 1],
    [223, "LR001", "대돈", 5],
    [224, "LR002", "행간", 5],
    [225, "LR003", "태충", 5],
    [226, "LR004", "중봉", 5],
    [227, "LR005", "여구", 5],
    [228, "LR006", "중도", 5],
    [229, "LR007", "슬관", 5],
    [230, "LR008", "곡천", 5],
    [231, "LR009", "음포", 5],
    [232, "LR010", "족오리", 5],
    [233, "LR011", "음렴", 5],
    [234, "LR012", "급맥", 5],
    [235, "LR013", "장문", 2],
    [236, "LR014", "기문", 2],
    [237, "LU001", "중부", 2],
    [238, "LU002", "운문", 2],
    [239, "LU003", "천부", 4],
    [240, "LU004", "협백", 4],
    [241, "LU005", "척택", 4],
    [242, "LU006", "공최", 4],
    [243, "LU007", "열결", 4],
    [244, "LU008", "경거", 4],
    [245, "LU009", "태연", 4],
    [246, "LU010", "어제", 4],
    [247, "LU011", "소상", 4],
    [248, "PC001", "천지", 2],
    [249, "PC002", "천천", 4],
    [250, "PC003", "곡택", 4],
    [251, "PC004", "극문", 4],
    [252, "PC005", "간사", 4],
    [253, "PC006", "내관", 4],
    [254, "PC007", "대릉", 4],
    [255, "PC008", "노궁", 4],
    [256, "PC009", "중충", 4],
    [257, "SI001", "소택", 4],
    [258, "SI002", "전곡", 4],
    [259, "SI003", "후계", 4],
    [260, "SI004", "완골", 4],
    [261, "SI005", "양곡", 4],
    [262, "SI006", "양노", 4],
    [263, "SI007", "지정", 4],
    [264, "SI008", "소해", 4],
    [265, "SI009", "견정", 4],
    [266, "SI010", "노수", 3],
    [267, "SI011", "천종", 3],
    [268, "SI012", "병풍", 3],
    [269, "SI013", "곡원", 3],
    [270, "SI014", "견외수", 3],
    [271, "SI015", "견중수", 3],
    [272, "SI016", "천창", 1],
    [273, "SI017", "천용", 1],
    [274, "SI018", "관료", 1],
    [275, "SI019", "청궁", 1],
    [276, "SP001", "은백", 5],
    [277, "SP002", "대도", 5],
    [278, "SP003", "태백", 5],
    [279, "SP004", "공손", 5],
    [280, "SP005", "상구", 5],
    [281, "SP006", "삼음교", 5],
    [282, "SP007", "누곡", 5],
    [283, "SP008", "지기", 5],
    [284, "SP009", "음릉천", 5],
    [285, "SP010", "혈해", 5],
    [286, "SP011", "기문", 5],
    [287, "SP012", "충문", 2],
    [288, "SP013", "부사", 2],
    [289, "SP014", "복결", 2],
    [290, "SP015", "대횡", 2],
    [291, "SP016", "복애", 2],
    [292, "SP017", "식두", 2],
    [293, "SP018", "천계", 2],
    [294, "SP019", "흉향", 2],
    [295, "SP020", "주영", 2],
    [296, "SP021", "대포", 2],
    [297, "ST001", "승읍", 1],
    [298, "ST002", "사백", 1],
    [299, "ST003", "거료", 1],
    [300, "ST004", "지창", 1],
    [301, "ST005", "대영", 1],
    [302, "ST006", "협거", 1],
    [303, "ST007", "하관", 1],
    [304, "ST008", "두유", 1],
    [305, "ST009", "인영", 1],
    [306, "ST010", "수돌", 1],
    [307, "ST011", "기사", 2],
    [308, "ST012", "결분", 2],
    [309, "ST013", "기호", 2],
    [310, "ST014", "고방", 2],
    [311, "ST015", "옥예", 2],
    [312, "ST016", "응창", 2],
    [313, "ST017", "유중", 2],
    [314, "ST018", "유근", 2],
    [315, "ST019", "불용", 2],
    [316, "ST020", "승만", 2],
    [317, "ST021", "양문", 2],
    [318, "ST022", "관문", 2],
    [319, "ST023", "태을", 2],
    [320, "ST024", "활육문", 2],
    [321, "ST025", "천추", 2],
    [322, "ST026", "외릉", 2],
    [323, "ST027", "대거", 2],
    [324, "ST028", "수도", 2],
    [325, "ST029", "귀래", 2],
    [326, "ST030", "기충", 2],
    [327, "ST031", "비관", 5],
    [328, "ST032", "복토", 5],
    [329, "ST033", "음시", 5],
    [330, "ST034", "양구", 5],
    [331, "ST035", "독비", 5],
    [332, "ST036", "족삼리", 5],
    [333, "ST037", "상거허", 5],
    [334, "ST038", "조구", 5],
    [335, "ST039", "하거허", 5],
    [336, "ST040", "풍륭", 5],
    [337, "ST041", "해계", 5],
    [338, "ST042", "충양", 5],
    [339, "ST043", "함곡", 5],
    [340, "ST044", "내정", 5],
    [341, "ST045", "여태", 5],
    [342, "TE001", "관충", 4],
    [343, "TE002", "액문", 4],
    [344, "TE003", "중저", 4],
    [345, "TE004", "양지", 4],
    [346, "TE005", "외관", 4],
    [347, "TE006", "지구", 4],
    [348, "TE007", "회종", 4],
    [349, "TE008", "삼양락", 4],
    [350, "TE009", "사독", 4],
    [351, "TE010", "천정", 4],
    [352, "TE011", "청냉연", 4],
    [353, "TE012", "소락", 4],
    [354, "TE013", "노회", 4],
    [355, "TE014", "견료", 4],
    [356, "TE015", "천료", 4],
    [357, "TE016", "천유", 1],
    [358, "TE017", "예풍", 1],
    [359, "TE018", "계맥", 1],
    [360, "TE019", "노식", 1],
    [361, "TE020", "각손", 1],
    [362, "TE021", "이문", 1],
    [363, "TE022", "화료", 1],
    [364, "TE023", "사죽공", 1],
    [365, "UE007", "극문[UE]", 2],
    [366, "UE010", "이백", 4],
    [367, "UE219", "환소", 4],
    [368, "BA001", "척삼", 3],
    [369, "BA002", "견중유", 3],
    [370, "BA003", "결핵혈", 3],
    [371, "BA004", "하백로", 3],
    [372, "BA005", "백종풍", 3],
    [373, "BA006", "정천[1]", 3],
    [374, "BA007", "치천", 3],
    [375, "BA008", "외정천", 3],
    [376, "BA009", "평천", 3],
    [377, "BA010", "팔요혈", 3],
    [378, "BA011", "거궐수", 3],
    [379, "BA012", "건명", 3],
    [380, "BA013", "결핵", 3],
    [381, "BA014", "계단지구", 3],
    [382, "BA015", "견상", 3],
    [383, "BA016", "경문사화혈", 3],
    [384, "BA017", "경혈", 3],
    [385, "BA018", "구로[신주혈상방]", 3],
    [386, "BA019", "구로[3흉추양측]", 3],
    [387, "BA020", "구연환", 3],
    [388, "BA021", "구효", 3],
    [389, "BA022", "기죽마", 3],
    [390, "BA023", "기천", 3],
    [391, "BA024", "나력", 3],
    [392, "BA025", "대변난", 3],
    [393, "BA026", "대추사화", 3],
    [394, "BA027", "독수", 3],
    [395, "BA028", "독척", 3],
    [396, "BA029", "양안", 3],
    [397, "BA030", "맥립종", 3],
    [398, "BA031", "무명혈[1]", 3],
    [399, "BA032", "배감[1]", 3],
    [400, "BA033", "배부지오주", 3],
    [401, "BA034", "비횡", 3],
    [402, "BA035", "사차", 3],
    [403, "BA036", "사화", 3],
    [404, "BA037", "사화환문", 3],
    [405, "BA038", "신사화", 3],
    [406, "BA039", "안안3", 3],
    [407, "BA040", "양추", 3],
    [408, "BA041", "양반", 3],
    [409, "BA042", "열부", 3],
    [410, "BA043", "오장수", 3],
    [411, "BA044", "궤양혈", 3],
    [412, "BA045", "육화", 3],
    [413, "BA046", "팔화", 3],
    [414, "BA047", "위병육지구", 3],
    [415, "BA048", "위관하수삼혈", 3],
    [416, "BA049", "위해", 3],
    [417, "BA050", "장수", 3],
    [418, "BA051", "전간", 3],
    [419, "BA052", "전시로", 3],
    [420, "BA053", "안골", 3],
    [421, "BA054", "정근", 5],
    [422, "BA055", "중초유", 3],
    [423, "BA056", "중천[1]", 3],
    [424, "BA057", "중풍불어", 3],
    [425, "BA058", "주측", 3],
    [426, "BA059", "지양육지구", 3],
    [427, "BA060", "지명오", 3],
    [428, "BA061", "척봉", 3],
    [429, "BA062", "추변", 3],
    [430, "BA063", "췌수", 3],
    [431, "BA064", "치근[1]", 3],
    [432, "BA065", "팔추하", 3],
    [433, "BA066", "폐열혈", 3],
    [434, "BA067", "위열혈", 3],
    [435, "BA068", "간열혈", 3],
    [436, "BA069", "비열혈", 3],
    [437, "BA070", "진열혈", 3],
    [438, "BA071", "타척", 3],
    [439, "BA072", "탁곡", 3],
    [440, "BA073", "해수", 3],
    [441, "BA074", "환문", 3],
    [442, "BA075", "척추혈", 3],
    [443, "BA076", "오령혈", 3],
    [444, "BA077", "상봉혈", 3],
    [445, "BA078", "구후혈", 3],
    [446, "BA079", "삼금혈", 3],
    [447, "BA080", "후심혈", 3],
    [448, "BA081", "감모삼혈", 3],
    [449, "BA082", "감조창", 3],
    [450, "BA083", "관원수", 3],
    [451, "BA084", "계상", 3],
    [452, "BA085", "기해수", 3],
    [453, "BA086", "경문", 3],
    [454, "BA087", "구종풍제치", 3],
    [455, "BA088", "굴진1", 3],
    [456, "BA089", "굴진2", 3],
    [457, "BA090", "굴진3", 3],
    [458, "BA091", "둔압", 3],
    [459, "BA092", "명문[1]", 3],
    [460, "BA093", "비근", 3],
    [461, "BA094", "상자구", 3],
    [462, "BA095", "하자구", 3],
    [463, "BA096", "상선", 3],
    [464, "BA097", "소아구벽", 3],
    [465, "BA098", "소력", 3],
    [466, "BA099", "신신", 3],
    [467, "BA100", "신척", 3],
    [468, "BA101", "십칠추하", 3],
    [469, "BA102", "오처", 3],
    [470, "BA103", "요목", 3],
    [471, "BA104", "요부팔혈", 3],
    [472, "BA105", "요료", 3],
    [473, "BA106", "요안", 3],
    [474, "BA107", "요관", 3],
    [475, "BA108", "위서", 3],
    [476, "BA109", "자궁출혈", 3],
    [477, "BA110", "장풍", 3],
    [478, "BA111", "적취비괴", 3],
    [479, "BA112", "혈부", 3],
    [480, "BA113", "전탄", 3],
    [481, "BA114", "정요", 3],
    [482, "BA115", "정궁", 3],
    [483, "BA116", "주추", 3],
    [484, "BA117", "죽장", 3],
    [485, "BA118", "중공", 3],
    [486, "BA119", "지실", 3],
    [487, "BA120", "척배오혈", 3],
    [488, "BA121", "치창", 3],
    [489, "BA122", "하극수", 3],
    [490, "BA123", "혈수", 3],
    [491, "BA124", "협척", 3],
    [492, "BA125", "수중혈", 3],
    [493, "BA126", "수부혈", 3],
    [494, "BA127", "삼강혈", 3],
    [495, "BA128", "쌍하혈", 3],
    [496, "BA129", "가후상자", 3],
    [497, "BA130", "구기", 3],
    [498, "BA131", "구혈병", 3],
    [499, "BA132", "권중", 3],
    [500, "BA133", "맥근", 3],
    [501, "BA134", "미골방", 3],
    [502, "BA135", "미궁골", 3],
    [503, "BA136", "빈혈령", 3],
    [504, "BA137", "소아감리", 3],
    [505, "BA138", "상후장골자", 3],
    [506, "BA139", "심요유", 3],
    [507, "BA140", "옥전", 3],
    [508, "BA141", "요근", 3],
    [509, "BA142", "요기", 3],
    [510, "BA143", "요중", 3],
    [511, "BA144", "여상", 3],
    [512, "BA145", "영위사혈", 3],
    [513, "BA146", "음반", 3],
    [514, "BA147", "임천", 3],
    [515, "BA148", "제22추양방", 3],
    [516, "BA149", "도약", 3],
    [517, "BA150", "칠보반", 3],
    [518, "BA151", "하요", 3],
    [519, "BA152", "하추", 3],
    [520, "BA153", "하초수", 3],
    [521, "BA154", "환강", 3],
    [522, "BA155", "환도[1]", 3],
    [523, "BA156", "회기", 3],
    [524, "BA157", "항문사혈", 3],
    [525, "BA158", "충소혈", 3],
    [526, "BA159", "갑봉", 3],
    [527, "BA160", "거각", 3],
    [528, "BA161", "거골하", 3],
    [529, "BA162", "견두", 3],
    [530, "BA163", "견통점", 3],
    [531, "BA164", "견주골", 3],
    [532, "BA165", "배갑중간", 3],
    [533, "BA166", "배봉", 3],
    [534, "BA167", "은구", 3],
    [535, "BA168", "해마", 3],
    [536, "BA169", "분지상", 3],
    [537, "BA170", "분지하", 3],
    [538, "BA171", "정지", 3],
    [539, "BA172", "금림", 3],
    [540, "BA173", "정주", 3],
    [541, "BA174", "제고", 3],
    [542, "BA175", "고위수", 3],
    [543, "BA176", "저위", 3],
    [544, "BA177", "저위수", 3],
    [545, "BA178", "절상", 3],
    [546, "BA179", "절하", 3],
    [547, "CA001", "용함", 2],
    [548, "CA002", "적혈", 2],
    [549, "CA003", "신늑두", 2],
    [550, "CA004", "흉당", 2],
    [551, "CA005", "폐모", 2],
    [552, "CA006", "덕흥", 2],
    [553, "CA007", "소아구흉", 2],
    [554, "CA008", "이기문", 2],
    [555, "CA009", "유상", 2],
    [556, "CA010", "유방", 2],
    [557, "CA011", "귀문", 2],
    [558, "CA012", "직골", 2],
    [559, "CA013", "유하", 2],
    [560, "CA014", "마기반", 2],
    [561, "CA015", "설식", 2],
    [562, "CA016", "통곡", 2],
    [563, "CA017", "절학", 2],
    [564, "CA018", "맹모", 2],
    [565, "CA019", "액역", 2],
    [566, "CA020", "좌의", 2],
    [567, "CA021", "우의", 2],
    [568, "CA022", "기문[6-7늑간]", 2],
    [569, "CA023", "기문[7-8늑간]", 2],
    [570, "CA024", "석관", 2],
    [571, "CA025", "좌수", 2],
    [572, "CA026", "우수", 2],
    [573, "CA027", "늑두", 2],
    [574, "CA028", "담천", 2],
    [575, "CA029", "음극", 2],
    [576, "CA030", "응돌", 2],
    [577, "CA031", "명관", 2],
    [578, "CA032", "견내우", 2],
    [579, "CA033", "천령", 2],
    [580, "CA034", "전시", 2],
    [581, "CA035", "늑하", 2],
    [582, "CA036", "전곡", 2],
    [583, "CA037", "시소", 2],
    [584, "CA038", "액문", 2],
    [585, "CA039", "액하", 2],
    [586, "CA040", "협당", 2],
    [587, "CA041", "방정", 2],
    [588, "CA042", "주시", 2],
    [589, "CA043", "구곡중부", 2],
    [590, "CA044", "액기", 2],
    [591, "CA045", "폐문", 2],
    [592, "CA046", "가거", 2],
    [593, "CA047", "간방", 2],
    [594, "CA048", "간실", 2],
    [595, "CA049", "제위", 2],
    [596, "CA050", "유해", 2],
    [597, "CA051", "비총", 2],
    [598, "CA052", "흉대기", 2],
    [599, "CA053", "창신문", 2],
    [600, "CA054", "미주", 2],
    [601, "CA055", "아성혈사", 2],
    [602, "CA056", "복늑두", 2],
    [603, "CA057", "견수", 2],
    [604, "CA058", "견내수", 2],
    [605, "CA059", "기문[3늑간]", 2],
    [606, "CA060", "구번위", 2],
    [607, "CA061", "액령", 2],
    [608, "CA062", "홍점혈", 2],
    [609, "CA063", "심하이촌이분", 2],
    [610, "CA064", "원수", 2],
    [611, "CA065", "유두", 2],
    [612, "CA066", "양유상제3늑간", 2],
    [613, "CA067", "양유하1지", 2],
    [614, "CA068", "양유하흑백육제", 2],
    [615, "CA069", "양유문", 2],
    [616, "CA070", "양유두", 2],
    [617, "CA071", "소아식간", 2],
    [618, "CA072", "신부", 2],
    [619, "CA073", "구미골", 2],
    [620, "CA074", "연초점", 2],
    [621, "CA075", "매화", 2],
    [622, "CA076", "풍비", 2],
    [623, "CA077", "난문[1]", 2],
    [624, "CA078", "제중사변", 2],
    [625, "CA079", "제상하오분", 2],
    [626, "CA080", "신교", 2],
    [627, "CA081", "제상하", 2],
    [628, "CA082", "단전", 2],
    [629, "CA083", "절잉", 2],
    [630, "CA084", "관촌", 2],
    [631, "CA085", "중갑", 2],
    [632, "CA086", "통관", 5],
    [633, "CA087", "졸복통", 2],
    [634, "CA088", "정두", 2],
    [635, "CA089", "흥륭", 2],
    [636, "CA090", "혼사", 2],
    [637, "CA091", "삼각구", 2],
    [638, "CA092", "유정", 2],
    [639, "CA093", "식관[제상3촌]", 2],
    [640, "CA094", "좌우관", 2],
    [641, "CA095", "수분", 2],
    [642, "CA096", "기중", 2],
    [643, "CA097", "사만[제하2촌]", 2],
    [644, "CA098", "포만자호", 2],
    [645, "CA099", "장요", 2],
    [646, "CA100", "소강", 2],
    [647, "CA101", "전공", 2],
    [648, "CA102", "장곡", 2],
    [649, "CA103", "장유", 2],
    [650, "CA104", "수도", 2],
    [651, "CA105", "자궁[제하6촌]", 2],
    [652, "CA106", "식창", 2],
    [653, "CA107", "식관[제상4촌]", 2],
    [654, "CA108", "맹장", 2],
    [655, "CA109", "경중[1]", 2],
    [656, "CA110", "기문[제하3촌]", 2],
    [657, "CA111", "자궁[제하4촌]", 2],
    [658, "CA112", "천음", 2],
    [659, "CA113", "횡문[1]", 2],
    [660, "CA114", "자장", 2],
    [661, "CA115", "유도", 2],
    [662, "CA116", "육문", 2],
    [663, "CA117", "복사", 2],
    [664, "CA118", "지사", 2],
    [665, "CA119", "중극하", 2],
    [666, "CA120", "금하", 2],
    [667, "CA121", "퇴회", 2],
    [668, "CA122", "폐신", 2],
    [669, "CA123", "위상[1]", 2],
    [670, "CA124", "야뇨[1]", 2],
    [671, "CA125", "절구", 2],
    [672, "CA126", "상위", 2],
    [673, "CA127", "담강", 2],
    [674, "CA128", "신수[1]", 2],
    [675, "CA129", "호관", 2],
    [676, "CA130", "용문[전중혈하방]", 2],
    [677, "CA131", "간기", 2],
    [678, "CA132", "간명", 2],
    [679, "CA133", "담낭[1]", 2],
    [680, "CA134", "위하수", 2],
    [681, "CA135", "통변", 2],
    [682, "CA136", "충간", 2],
    [683, "CA137", "강충", 2],
    [684, "CA138", "혁명혈", 2],
    [685, "CA139", "치간", 2],
    [686, "CA140", "위상[2]", 2],
    [687, "CA141", "위악", 2],
    [688, "CA142", "제궁[1]", 2],
    [689, "CA143", "통경", 2],
    [690, "CA144", "제탁", 2],
    [691, "CA145", "마씨점", 2],
    [692, "CA146", "서혜", 2],
    [693, "CA147", "가전상", 2],
    [694, "CA148", "복기송", 2],
    [695, "CA149", "수상", 2],
    [696, "CA150", "신기혈", 2],
    [697, "CA151", "자궁경", 2],
    [698, "CA152", "아시혈오", 2],
    [699, "CA153", "운문", 2],
    [700, "CA154", "하월", 2],
    [701, "CA155", "사만[제하3촌]", 2],
    [702, "CA156", "소복횡문", 2],
    [703, "CA157", "구하벽", 2],
    [704, "CA158", "음도", 2],
    [705, "CA159", "기백구", 2],
    [706, "CA160", "횡골", 2],
    [707, "CA161", "용골", 2],
    [708, "CA162", "하곡골", 2],
    [709, "CA163", "옥천[1]", 2],
    [710, "CA164", "졸전", 2],
    [711, "CA165", "세두", 2],
    [712, "CA166", "천문", 2],
    [713, "CA167", "용문[여성외음부]", 2],
    [714, "CA168", "옥문", 2],
    [715, "CA169", "요루", 2],
    [716, "CA170", "남음봉", 2],
    [717, "CA171", "음낭봉", 2],
    [718, "CA172", "낭하봉", 2],
    [719, "CA173", "음낭하횡문", 2],
    [720, "CA174", "낭저", 2],
    [721, "CA175", "금문[1]", 2],
    [722, "CA176", "양시", 2],
    [723, "CA177", "퇴산", 2],
    [724, "CA178", "제하육일", 2],
    [725, "CA179", "관문", 2],
    [726, "CA180", "각문", 2],
    [727, "CA181", "음륜", 2],
    [728, "CA182", "전회음", 2],
    [729, "CA183", "제항기", 2],
    [730, "CA184", "양문", 2],
    [731, "CA185", "치근[2]", 2],
    [732, "CA186", "열혈", 2],
    [733, "CA187", "승항", 2],
    [734, "CA188", "항주", 2],
    [735, "CA189", "호항", 2],
    [736, "CA190", "회음마취점", 2],
    [737, "CA191", "저요", 2],
    [738, "CA192", "음변", 2],
    [739, "CA193", "급맥", 2],
    [740, "HN002", "액중", 1],
    [741, "HN003", "전발제", 1],
    [742, "HN004", "독맥", 1],
    [743, "HN005", "천정[1]", 1],
    [744, "HN006", "신중", 1],
    [745, "HN007", "인문", 1],
    [746, "HN008", "목명", 1],
    [747, "HN009", "목비", 1],
    [748, "HN010", "당양", 1],
    [749, "HN011", "발제", 1],
    [750, "HN012", "반성", 1],
    [751, "HN013", "두봉", 1],
    [752, "HN014", "삽화", 1],
    [753, "HN015", "측발제", 1],
    [754, "HN016", "명당[1]", 1],
    [755, "HN017", "미충", 1],
    [756, "HN018", "액상", 1],
    [757, "HN019", "천총[두정정중선]", 1],
    [758, "HN020", "학정[1]", 1],
    [759, "HN021", "전신총", 1],
    [760, "HN022", "후신총", 1],
    [761, "HN023", "사신총", 1],
    [762, "HN024", "전상회모", 1],
    [763, "HN025", "외발오처", 1],
    [764, "HN026", "구학", 1],
    [765, "HN027", "대문", 1],
    [766, "HN028", "사중", 1],
    [767, "HN029", "이문전맥", 1],
    [768, "HN030", "울증", 1],
    [769, "HN031", "삼음삼양", 1],
    [770, "HN032", "이상발제", 1],
    [771, "HN033", "이상", 1],
    [772, "HN034", "태양태음", 1],
    [773, "HN035", "두섭", 1],
    [774, "HN036", "광채", 1],
    [775, "HN037", "정중", 1],
    [776, "HN038", "태시태소", 1],
    [777, "HN039", "내정명", 1],
    [778, "HN040", "뇌정", 1],
    [779, "HN042", "두광명", 1],
    [780, "HN043", "섭유", 1],
    [781, "HN044", "어미", 1],
    [782, "HN045", "구후", 1],
    [783, "HN046", "태양", 1],
    [784, "HN047", "당용", 1],
    [785, "HN048", "관골[1]", 1],
    [786, "HN049", "상정명", 1],
    [787, "HN050", "하정명", 1],
    [788, "HN051", "건명[정명하6분]", 1],
    [789, "HN052", "건명[건명승읍간]", 1],
    [790, "HN053", "건명[승읍구후간]", 1],
    [791, "HN054", "건명[구후외상]", 1],
    [792, "HN055", "건명[상정명상3분]", 1],
    [793, "HN056", "상명", 1],
    [794, "HN057", "증명[상명내측]", 1],
    [795, "HN058", "증명[상명외측]", 1],
    [796, "HN059", "외명", 1],
    [797, "HN060", "신찬죽", 1],
    [798, "HN061", "소산", 1],
    [799, "HN062", "정신", 1],
    [800, "HN063", "연구", 1],
    [801, "HN064", "상은리", 1],
    [802, "HN065", "현명[1]", 1],
    [803, "HN066", "상악", 1],
    [804, "HN067", "취천", 1],
    [805, "HN068", "설하혈", 1],
    [806, "HN069", "해천", 1],
    [807, "HN070", "좌금진우옥액", 1],
    [808, "HN071", "중구", 1],
    [809, "HN072", "설주", 1],
    [810, "HN073", "순리", 1],
    [811, "HN074", "협리", 1],
    [812, "HN075", "은교선", 1],
    [813, "HN076", "지합", 1],
    [814, "HN077", "조각", 1],
    [815, "HN078", "협승장", 1],
    [816, "HN079", "해료", 1],
    [817, "HN080", "면암", 1],
    [818, "HN081", "아교", 1],
    [819, "HN082", "귀상", 1],
    [820, "HN083", "하관하오분", 1],
    [821, "HN084", "기관", 1],
    [822, "HN085", "견정", 1],
    [823, "HN086", "외금진옥액", 1],
    [824, "HN087", "아혈", 1],
    [825, "HN088", "상염천", 1],
    [826, "HN089", "홍음", 1],
    [827, "HN090", "방염천", 1],
    [828, "HN091", "아근", 1],
    [829, "HN092", "천구방혈", 1],
    [830, "HN093", "기당", 1],
    [831, "HN094", "강음", 1],
    [832, "HN095", "증음", 1],
    [833, "HN096", "지구", 1],
    [834, "HN097", "기영", 1],
    [835, "HN098", "후아구혈", 1],
    [836, "HN099", "풍암", 1],
    [837, "HN100", "예명", 1],
    [838, "HN101", "경비", 1],
    [839, "HN102", "편도", 1],
    [840, "HN103", "낙경", 1],
    [841, "HN104", "전지", 1],
    [842, "HN105", "견배", 1],
    [843, "HN106", "백후혈일", 1],
    [844, "HN107", "이상자점", 1],
    [845, "HN108", "안면[예풍풍지간]", 1],
    [932, "LE036", "낭음", 5],
    [846, "HN109", "안면[예풍예명간]", 1],
    [847, "HN110", "진정", 1],
    [848, "HN111", "흥분", 1],
    [849, "HN112", "용후", 1],
    [850, "HN113", "경중[2]", 1],
    [851, "HN114", "지신[1]", 1],
    [852, "HN115", "하부돌", 1],
    [853, "HN116", "쇄외", 1],
    [854, "HN117", "호흡", 1],
    [855, "HN118", "치농신3호", 1],
    [856, "HN119", "하예풍", 1],
    [857, "HN120", "예명하", 1],
    [858, "HN121", "통이도", 1],
    [859, "HN122", "아명", 1],
    [860, "HN123", "천총[안면2혈하]", 1],
    [861, "HN124", "암지", 1],
    [862, "HN125", "지전", 1],
    [863, "HN126", "후청궁", 1],
    [864, "HN127", "후청혈", 1],
    [865, "HN128", "후총", 1],
    [866, "HN129", "의롱", 1],
    [867, "HN130", "숭골", 1],
    [868, "HN131", "백로", 1],
    [869, "HN132", "신식", 1],
    [870, "HN133", "신설", 1],
    [871, "HN134", "천종", 1],
    [872, "HN135", "제6경추방", 1],
    [873, "HN136", "혈압점", 1],
    [874, "HN137", "중접", 1],
    [875, "HN138", "명당[2]", 1],
    [876, "HN139", "뉵혈", 1],
    [877, "HN140", "천주", 1],
    [878, "HN141", "일희", 1],
    [879, "HN142", "정추", 1],
    [880, "HN143", "배감[2]", 1],
    [881, "HN144", "양혈", 1],
    [882, "HN145", "음혈", 1],
    [883, "HN146", "옥천[2]", 1],
    [884, "HN147", "천식", 1],
    [885, "HN148", "제7경추방", 1],
    [886, "HN149", "하아문", 1],
    [887, "HN150", "부아문", 1],
    [888, "HN151", "신일", 1],
    [889, "HN152", "하신식", 1],
    [890, "HN153", "지갑", 1],
    [891, "HN154", "지하", 1],
    [892, "HN155", "상천근", 1],
    [893, "HN156", "총추혈", 1],
    [894, "HN157", "백로사혈", 1],
    [895, "HN158", "치뇌1-5", 1],
    [896, "HN159", "칠성혈", 1],
    [897, "LE001", "치변", 5],
    [898, "LE002", "이변", 5],
    [899, "LE003", "방강", 5],
    [900, "LE004", "좌골[저골]", 5],
    [901, "LE005", "둔대기운동점", 5],
    [902, "LE006", "폐공", 5],
    [903, "LE007", "타안", 5],
    [904, "LE008", "음승", 5],
    [905, "LE009", "분신경자극점", 5],
    [906, "LE010", "신환도[미골첨양방]", 5],
    [907, "LE011", "청아", 5],
    [908, "LE012", "좌골[대전자]", 5],
    [909, "LE013", "가상", 5],
    [910, "LE014", "굴진4", 5],
    [911, "LE015", "환도[2]", 5],
    [912, "LE016", "도도", 5],
    [913, "LE017", "제궁[2]", 5],
    [914, "LE018", "중해", 5],
    [915, "LE019", "신환도[미골첨상방]", 5],
    [916, "LE020", "둔중근운동점", 5],
    [917, "LE021", "요통2", 5],
    [918, "LE022", "건과", 5],
    [919, "LE023", "요통3", 5],
    [920, "LE024", "섬전", 5],
    [921, "LE025", "환변", 5],
    [922, "LE026", "유포", 5],
    [923, "LE027", "유궁", 5],
    [924, "LE028", "신건", 5],
    [925, "LE029", "후기문", 5],
    [926, "LE030", "둔중", 5],
    [927, "LE031", "환중", 5],
    [928, "LE032", "횡현", 5],
    [929, "LE033", "관구", 5],
    [930, "LE034", "강렴", 5],
    [931, "LE035", "외음과", 5],
    [933, "LE037", "반수", 5],
    [934, "LE038", "고박근운동점", 5],
    [935, "LE039", "기하", 5],
    [936, "LE040", "해전", 5],
    [937, "LE041", "혈해상", 5],
    [938, "LE042", "신생", 5],
    [939, "LE043", "방수", 5],
    [940, "LE044", "홍선", 5],
    [941, "LE045", "지양[1]", 5],
    [942, "LE046", "후혈해", 5],
    [943, "LE047", "슬개절통2", 5],
    [944, "LE048", "내하해", 5],
    [945, "LE049", "치골근운동점", 5],
    [946, "LE050", "장수근운동점", 5],
    [947, "LE051", "대수근운동점", 5],
    [948, "LE052", "관전하", 5],
    [949, "LE053", "대퇴", 5],
    [950, "LE054", "봉장근운동점", 5],
    [951, "LE055", "대퇴점", 5],
    [952, "LE056", "제궁2", 5],
    [953, "LE057", "고내수", 5],
    [954, "LE058", "비하", 5],
    [955, "LE059", "하지탄탄", 5],
    [956, "LE060", "생근", 5],
    [957, "LE061", "교혈", 5],
    [958, "LE062", "매보", 5],
    [959, "LE063", "관토", 5],
    [960, "LE064", "복토상", 5],
    [961, "LE065", "입지", 5],
    [962, "LE066", "고직근운동점", 5],
    [963, "LE067", "신복토", 5],
    [964, "LE068", "입공", 5],
    [965, "LE069", "고외근운동점", 5],
    [966, "LE070", "사강", 5],
    [967, "LE071", "생근2", 5],
    [968, "LE072", "학정상", 5],
    [969, "LE073", "고내근운동점", 5],
    [970, "LE074", "건슬", 5],
    [971, "LE075", "정상", 5],
    [972, "LE076", "슬관절통[슬개골양방]", 5],
    [973, "LE077", "족상오리", 5],
    [974, "LE078", "풍시상", 5],
    [975, "LE079", "전진", 5],
    [976, "LE080", "상풍시", 5],
    [977, "LE081", "전풍시", 5],
    [978, "LE082", "족하오리", 5],
    [979, "LE083", "상양관", 5],
    [980, "LE084", "후습관", 5],
    [981, "LE085", "슬관절통[양구혈하]", 5],
    [982, "LE086", "기황", 5],
    [983, "LE087", "음항", 5],
    [984, "LE088", "든상", 5],
    [985, "LE089", "고이두근운동점", 5],
    [986, "LE090", "반막근운동점", 5],
    [987, "LE091", "과신", 5],
    [988, "LE092", "절탄", 5],
    [989, "LE093", "직립", 5],
    [990, "LE094", "외직립", 5],
    [991, "LE095", "위위", 5],
    [992, "LE096", "위상[3]", 5],
    [993, "LE097", "해경2", 5],
    [994, "LE098", "해경1", 5],
    [995, "LE099", "오리", 5],
    [996, "LE100", "족라", 5],
    [997, "LE101", "난문[2]", 5],
    [998, "LE102", "백중와", 5],
    [999, "LE103", "족명", 5],
    [1000, "LE104", "대륜", 5],
    [1001, "LE105", "요요", 5],
    [1002, "LE106", "신계", 5],
    [1003, "LE107", "관골[2]", 5],
    [1004, "LE108", "퇴고", 5],
    [1005, "LE109", "슬상이혈", 5],
    [1006, "LE110", "학정[2]", 5],
    [1007, "LE111", "내외슬방", 5],
    [1008, "LE112", "두풍", 5],
    [1009, "LE113", "관의", 5],
    [1010, "LE114", "성골", 5],
    [1011, "LE115", "영보", 5],
    [1012, "LE116", "오령", 5],
    [1013, "LE117", "사련", 5],
    [1014, "LE118", "음위삼", 5],
    [1015, "LE119", "음위이", 5],
    [1016, "LE120", "음위", 5],
    [1017, "LE121", "슬외", 5],
    [1018, "LE122", "노근", 5],
    [1019, "LE123", "슬방", 5],
    [1020, "LE124", "상곡천", 5],
    [1021, "LE125", "가빈중", 5],
    [1022, "LE126", "사해", 5],
    [1023, "LE127", "탄복", 5],
    [1024, "LE128", "탄립", 5],
    [1025, "LE129", "탄강", 5],
    [1026, "LE130", "전호", 5],
    [1027, "LE131", "곡천", 5],
    [1028, "LE132", "은하", 5],
    [1029, "LE133", "구리", 5],
    [1030, "LE134", "비마이", 5],
    [1031, "LE135", "비마일", 5],
    [1032, "LE136", "비마삼", 5],
    [1033, "LE137", "해혈", 5],
    [1034, "LE138", "통산", 5],
    [1035, "LE139", "통천", 5],
    [1036, "LE140", "자매1.2.3", 5],
    [1037, "LE141", "외감", 5],
    [1038, "LE142", "통신", 5],
    [1039, "LE143", "통위", 5],
    [1040, "LE144", "통배", 5],
    [1041, "LE145", "진정선", 5],
    [1042, "LE146", "실음이혈", 5],
    [1043, "LE147", "명황", 5],
    [1044, "LE148", "천황", 5],
    [1045, "LE149", "나력구", 5],
    [1046, "LE150", "현명[2]", 5],
    [1047, "LE151", "양류", 5],
    [1048, "LE152", "이외", 5],
    [1049, "LE153", "족이리반", 5],
    [1050, "LE154", "담낭[2]", 5],
    [1051, "LE155", "만리", 5],
    [1052, "LE156", "비농", 5],
    [1053, "LE157", "뉴내번", 5],
    [1054, "LE158", "능하", 5],
    [1055, "LE159", "비두하", 5],
    [1056, "LE160", "건위", 5],
    [1057, "LE161", "치옹6", 5],
    [1058, "LE162", "족익총", 5],
    [1059, "LE163", "하풍륭", 5],
    [1060, "LE164", "규내번2", 5],
    [1061, "LE165", "족33", 5],
    [1062, "LE166", "비장", 5],
    [1063, "LE167", "비장근운동점", 5],
    [1064, "LE168", "승간", 5],
    [1065, "LE169", "규외번2", 5],
    [1066, "LE170", "규내번3", 5],
    [1067, "LE171", "승산하", 5],
    [1068, "LE172", "신1", 5],
    [1069, "LE173", "낙지", 5],
    [1070, "LE174", "비목어근운동점", 5],
    [1071, "LE175", "경골후근운동점", 5],
    [1072, "LE176", "승종", 5],
    [1073, "LE177", "굴무장근운동점", 5],
    [1074, "LE178", "태음", 5],
    [1075, "LE179", "음서", 5],
    [1076, "LE180", "지건", 5],
    [1077, "LE181", "내마취점", 5],
    [1078, "LE182", "이질민감점", 5],
    [1079, "LE183", "상삼음교", 5],
    [1080, "LE184", "규외번1", 5],
    [1081, "LE185", "간염", 5],
    [1082, "LE186", "상계", 5],
    [1083, "LE187", "슬관절통4", 5],
    [1084, "LE188", "슬전", 5],
    [1085, "LE189", "경골전근운동점", 5],
    [1086, "LE190", "비골장근운동점", 5],
    [1087, "LE191", "이중", 5],
    [1088, "LE192", "신지장근운동점", 5],
    [1089, "LE193", "외마취점", 5],
    [1090, "LE194", "야뇨[2]", 5],
    [1091, "LE195", "비골단근운동점", 5],
    [1092, "LE196", "경하", 5],
    [1093, "LE197", "신지장근운동점", 5],
    [1094, "LE198", "뇌청", 5],
    [1095, "LE199", "임백", 5],
    [1096, "LE200", "내용면", 5],
    [1097, "LE201", "슬안[독비양방]", 5],
    [1098, "LE202", "슬안", 5],
    [1099, "LE203", "족29", 5],
    [1100, "LE204", "교의", 5],
    [1101, "LE205", "족과상", 5],
    [1102, "LE206", "승명", 5],
    [1103, "LE207", "내과고", 5],
    [1104, "LE208", "욕단산", 5],
    [1105, "LE209", "소양유", 5],
    [1106, "LE210", "치전근", 5],
    [1107, "LE211", "슬하", 5],
    [1108, "LE212", "전승산", 5],
    [1109, "LE213", "전시구", 5],
    [1110, "LE214", "능후", 5],
    [1111, "LE215", "능후하", 5],
    [1112, "LE216", "담낭점", 5],
    [1113, "LE217", "중평[1]", 5],
    [1114, "LE218", "난미", 5],
    [1115, "LE219", "외과상", 5],
    [1116, "LE220", "절골", 5],
    [1117, "LE221", "각근상횡문중", 5],
    [1118, "LE222", "내과첨", 5],
    [1119, "LE223", "내곤륜", 5],
    [1120, "LE224", "족태음", 5],
    [1121, "LE225", "내과후", 5],
    [1122, "LE226", "외과첨", 5],
    [1123, "LE227", "뇌근", 5],
    [1124, "LE228", "족태양", 5],
    [1125, "LE229", "하곤륜", 5],
    [1126, "LE230", "거양", 5],
    [1127, "LE231", "외과전교맥", 5],
    [1128, "LE232", "족외과하용조외", 5],
    [1129, "LE233", "족양교", 5],
    [1130, "LE234", "족수공", 5],
    [1131, "LE235", "영지", 5],
    [1132, "LE236", "태양교", 5],
    [1133, "LE237", "누음", 5],
    [1134, "LE238", "내과전하", 5],
    [1135, "LE239", "태계", 5],
    [1136, "LE240", "곡척", 5],
    [1137, "LE241", "혜대", 5],
    [1138, "LE242", "족15", 5],
    [1139, "LE243", "연후", 5],
    [1140, "LE244", "출기혈", 5],
    [1141, "LE245", "과하", 5],
    [1142, "LE246", "무명혈[2]", 5],
    [1143, "LE247", "내과하삼지초사향전", 5],
    [1144, "LE248", "내지음", 5],
    [1145, "LE249", "중신", 5],
    [1146, "LE250", "족30", 5],
    [1147, "LE251", "족19", 5],
    [1148, "LE252", "절근", 5],
    [1149, "LE253", "신지단근운동점", 5],
    [1150, "LE254", "족17", 5],
    [1151, "LE255", "족20", 5],
    [1152, "LE256", "족양명", 5],
    [1153, "LE257", "족궐음", 5],
    [1154, "LE258", "족34", 5],
    [1155, "LE259", "족25", 5],
    [1156, "LE260", "족27", 5],
    [1157, "LE261", "족26", 5],
    [1158, "LE262", "내태충", 5],
    [1159, "LE263", "척송", 5],
    [1160, "LE264", "송이", 5],
    [1161, "LE265", "족23", 5],
    [1162, "LE266", "방곡", 5],
    [1163, "LE267", "족21", 5],
    [1164, "LE268", "통리", 5],
    [1165, "LE269", "팔충", 5],
    [1166, "LE270", "골간배측기운동점", 5],
    [1167, "LE271", "음양", 5],
    [1168, "LE272", "백식", 5],
    [1169, "LE273", "무지표횡문", 5],
    [1170, "LE274", "무지취모", 5],
    [1171, "LE275", "무지회리삼모", 5],
    [1172, "LE276", "감근", 5],
    [1173, "LE277", "구산", 5],
    [1174, "LE278", "족대지내측거단1촌", 5],
    [1175, "LE279", "양족대지조갑육제", 5],
    [1176, "LE280", "강압", 5],
    [1177, "LE281", "유뇨구", 5],
    [1178, "LE282", "족소양", 5],
    [1179, "LE283", "여태", 5],
    [1180, "LE284", "이지상", 5],
    [1181, "LE285", "족이지상일촌반", 5],
    [1182, "LE286", "족대지절", 5],
    [1183, "LE287", "내곡천", 5],
    [1184, "LE288", "목부", 5],
    [1185, "LE289", "소적", 5],
    [1186, "LE290", "족48", 5],
    [1187, "LE291", "음독", 5],
    [1188, "LE292", "족소지외측상문첨", 5],
    [1189, "LE293", "지평", 5],
    [1190, "LE294", "천생족", 5],
    [1191, "LE295", "서미", 5],
    [1192, "LE296", "여슬", 5],
    [1193, "LE297", "조태음태양", 5],
    [1194, "LE298", "내외과첨", 5],
    [1195, "LE299", "족양과", 5],
    [1196, "LE300", "족후사백", 5],
    [1197, "LE301", "족전사백", 5],
    [1198, "LE302", "족중충", 5],
    [1199, "LE303", "족46", 5],
    [1200, "LE304", "족47", 5],
    [1201, "LE305", "재생", 5],
    [1202, "LE306", "족1", 5],
    [1203, "LE307", "족50", 5],
    [1204, "LE308", "족51", 5],
    [1205, "LE309", "족화", 5],
    [1206, "LE310", "두구", 5],
    [1207, "LE311", "이구", 5],
    [1208, "LE312", "선저삼침", 5],
    [1209, "LE313", "족3", 5],
    [1210, "LE314", "소장구", 5],
    [1211, "LE315", "위구", 5],
    [1212, "LE316", "천근", 5],
    [1213, "LE317", "족4", 5],
    [1214, "LE318", "족2", 5],
    [1215, "LE319", "외곡천", 5],
    [1216, "LE320", "심포구", 5],
    [1217, "LE321", "삼초구", 5],
    [1218, "LE322", "천중", 5],
    [1219, "LE323", "족심", 5],
    [1220, "LE324", "전후은주", 5],
    [1221, "LE325", "심구", 5],
    [1222, "LE326", "용천", 5],
    [1223, "LE327", "목구", 5],
    [1224, "LE328", "암근", 5],
    [1225, "LE329", "대장구", 5],
    [1226, "LE330", "족5", 5],
    [1227, "LE331", "암근2", 5],
    [1228, "LE332", "기구", 5],
    [1229, "LE333", "족8", 5],
    [1230, "LE334", "암근1", 5],
    [1231, "LE335", "폐구", 5],
    [1232, "LE336", "족11", 5],
    [1233, "LE337", "간구", 5],
    [1234, "LE338", "천정[2]", 5],
    [1235, "LE339", "안심", 5],
    [1236, "LE340", "족45", 5],
    [1237, "LE341", "식상명구", 5],
    [1238, "LE342", "지문", 5],
    [1239, "LE343", "절문", 5],
    [1240, "LE344", "낭배정", 5],
    [1241, "LE345", "방광구", 5],
    [1242, "LE346", "족10", 5],
    [1243, "LE347", "족13", 5],
    [1244, "LE348", "담구", 5],
    [1245, "LE349", "신구", 5],
    [1246, "LE350", "족14", 5],
    [1247, "LE351", "무지이횡문", 5],
    [1248, "LE352", "대지갑하", 5],
    [1249, "LE353", "화타", 5],
    [1250, "LE354", "족대지단", 5],
    [1251, "LE355", "독음", 5],
    [1252, "LE356", "족44", 5],
    [1253, "LE357", "야정", 5],
    [1254, "LE358", "족소지단", 5],
    [1255, "LE359", "족소지", 5],
    [1256, "LE360", "우각소지단", 5],
    [1257, "UE001", "택전", 4],
    [1258, "UE002", "택하", 4],
    [1259, "UE003", "금문[2]", 4],
    [1260, "UE004", "수역주", 4],
    [1261, "UE005", "비석자두", 4],
    [1262, "UE006", "검거", 4],
    [1263, "UE008", "비간", 4],
    [1264, "UE009", "변독", 4],
    [1265, "UE011", "정수", 4],
    [1266, "UE012", "낙상", 4],
    [1267, "UE013", "응하", 4],
    [1268, "UE014", "뉴상혈", 4],
    [1269, "UE015", "삼남외", 4],
    [1270, "UE016", "상양노", 4],
    [1271, "UE017", "양일", 4],
    [1272, "UE018", "수수공", 4],
    [1273, "UE019", "중천[2]", 4],
    [1274, "UE020", "지천", 4],
    [1275, "UE021", "촌평", 4],
    [1276, "UE022", "수과", 4],
    [1277, "UE023", "횡문[2]", 4],
    [1278, "UE024", "고골", 4],
    [1279, "UE025", "연자", 4],
    [1280, "UE026", "수심주", 4],
    [1281, "UE027", "신수[2]", 4],
    [1282, "UE028", "중요", 4],
    [1283, "UE029", "촌요", 4],
    [1284, "UE030", "온류", 4],
    [1285, "UE031", "상아통", 4],
    [1286, "UE032", "척요", 4],
    [1287, "UE033", "요현", 4],
    [1288, "UE034", "신문", 4],
    [1289, "UE035", "하구", 4],
    [1290, "UE036", "고산", 4],
    [1291, "UE037", "주수", 4],
    [1292, "UE038", "침감", 4],
    [1293, "UE039", "삼지", 4],
    [1294, "UE040", "두주", 4],
    [1295, "UE041", "택중", 4],
    [1296, "UE042", "소아수경", 4],
    [1297, "UE043", "주첨", 4],
    [1298, "UE044", "충양", 4],
    [1299, "UE045", "홍지", 4],
    [1300, "UE046", "굴양위", 4],
    [1301, "UE047", "신곡지", 4],
    [1302, "UE048", "상곡지", 4],
    [1303, "UE049", "하협백", 4],
    [1304, "UE050", "지양[2]", 4],
    [1305, "UE051", "용설", 4],
    [1306, "UE052", "두충", 4],
    [1307, "UE053", "신주", 4],
    [1308, "UE054", "견명", 4],
    [1309, "UE055", "응상", 4],
    [1310, "UE056", "굉중", 4],
    [1311, "UE057", "노상[삼각근중앙]", 4],
    [1312, "UE058", "탈명", 4],
    [1313, "UE059", "외용설", 4],
    [1314, "UE060", "비파", 4],
    [1315, "UE061", "우전", 4],
    [1316, "UE062", "후액", 4],
    [1317, "UE063", "내견우", 4],
    [1318, "UE064", "대천", 4],
    [1319, "UE065", "전견우", 4],
    [1320, "UE066", "대견", 4],
    [1321, "UE067", "거비", 4],
    [1322, "UE068", "소괴", 4],
    [1323, "UE069", "치탄", 4],
    [1324, "UE070", "견삼침", 4],
    [1325, "UE071", "팔회", 4],
    [1326, "UE072", "육호", 4],
    [1327, "UE073", "칠호", 4],
    [1328, "UE074", "일와풍", 4],
    [1329, "UE075", "호구", 4],
    [1330, "UE076", "정령위령", 4],
    [1331, "UE077", "외로궁", 4],
    [1332, "UE078", "이인상마", 4],
    [1333, "UE079", "팔사", 4],
    [1334, "UE080", "팔관", 4],
    [1335, "UE081", "대도", 4],
    [1336, "UE082", "항강", 4],
    [1337, "UE083", "방호", 4],
    [1338, "UE084", "상도", 4],
    [1339, "UE085", "중도", 4],
    [1340, "UE086", "하도", 4],
    [1341, "UE087", "거첨", 4],
    [1342, "UE088", "오호", 4],
    [1343, "UE089", "소지절", 4],
    [1344, "UE090", "상합곡", 4],
    [1345, "UE091", "요통", 4],
    [1346, "UE092", "요퇴점", 4],
    [1347, "UE093", "발아오혈", 4],
    [1348, "UE094", "홍공", 4],
    [1349, "UE095", "홍양", 4],
    [1350, "UE096", "영홍", 4],
    [1351, "UE097", "상후계", 4],
    [1352, "UE098", "경련자극점", 4],
    [1353, "UE099", "전마점", 4],
    [1354, "UE100", "호변", 4],
    [1355, "UE101", "전두통점", 4],
    [1356, "UE102", "19호", 4],
    [1357, "UE103", "은문", 4],
    [1358, "UE104", "비출혈점", 4],
    [1359, "UE105", "신사호", 4],
    [1360, "UE106", "화기", 4],
    [1361, "UE107", "요사점", 4],
    [1362, "UE108", "공급", 4],
    [1363, "UE109", "통령", 4],
    [1364, "UE110", "삽차", 4],
    [1365, "UE111", "분중", 4],
    [1366, "UE112", "대골공", 4],
    [1367, "UE113", "귀곡", 4],
    [1368, "UE114", "대지갑근", 4],
    [1369, "UE115", "노상[무지외측]", 4],
    [1370, "UE116", "중상", 4],
    [1371, "UE117", "삼문", 4],
    [1372, "UE118", "일선문", 4],
    [1373, "UE119", "이선문", 4],
    [1374, "UE120", "중괴", 4],
    [1375, "UE121", "중지절", 4],
    [1376, "UE122", "오지절", 4],
    [1377, "UE123", "수태양", 4],
    [1378, "UE124", "소골공", 4],
    [1379, "UE125", "소지조문", 4],
    [1380, "UE126", "십왕", 4],
    [1381, "UE127", "인후점", 4],
    [1382, "UE128", "경항점", 4],
    [1383, "UE129", "좌골신경점", 4],
    [1384, "UE130", "척주점", 4],
    [1385, "UE131", "거상[수2-3지]", 4],
    [1386, "UE132", "학문", 4],
    [1387, "UE133", "거상[수3-4지]", 4],
    [1388, "UE134", "호금촌", 4],
    [1389, "UE135", "수사혈", 4],
    [1390, "UE136", "전두점", 4],
    [1391, "UE137", "이명", 4],
    [1392, "UE138", "퇴열점", 4],
    [1393, "UE139", "두정점", 4],
    [1394, "UE140", "소절", 4],
    [1395, "UE141", "회음점", 4],
    [1396, "UE142", "후두점", 4],
    [1397, "UE143", "봉명일이", 4],
    [1398, "UE144", "중지십기십절", 4],
    [1399, "UE145", "십이제", 4],
    [1400, "UE146", "합간", 4],
    [1401, "UE147", "구급후비", 4],
    [1402, "UE148", "양대수지봉", 4],
    [1403, "UE149", "봉안", 4],
    [1404, "UE150", "안점", 4],
    [1405, "UE151", "견점", 4],
    [1406, "UE152", "액역점", 4],
    [1407, "UE153", "수장후백육제", 4],
    [1408, "UE154", "맥문", 4],
    [1409, "UE155", "감모점", 4],
    [1410, "UE156", "지해", 4],
    [1411, "UE157", "판문", 4],
    [1412, "UE158", "내양지", 4],
    [1413, "UE159", "무지대장기운동점", 4],
    [1414, "UE160", "음지", 4],
    [1415, "UE161", "족근점", 4],
    [1416, "UE162", "소천심", 4],
    [1417, "UE163", "천심", 4],
    [1418, "UE164", "수심", 4],
    [1419, "UE165", "방노궁", 4],
    [1420, "UE166", "주하", 4],
    [1421, "UE167", "지신[2]", 4],
    [1422, "UE168", "굴무단근운동점", 4],
    [1423, "UE169", "어복", 4],
    [1424, "UE170", "위장점", 4],
    [1425, "UE171", "신2호", 4],
    [1426, "UE172", "편도체", 4],
    [1427, "UE173", "건리삼침", 4],
    [1428, "UE174", "무수기운동점", 4],
    [1429, "UE175", "신1호", 4],
    [1430, "UE176", "해천점", 4],
    [1431, "UE177", "아병", 4],
    [1432, "UE178", "정천[2]", 4],
    [1433, "UE179", "동자", 4],
    [1434, "UE180", "동선", 4],
    [1435, "UE181", "지관", 4],
    [1436, "UE182", "중평[2]", 4],
    [1437, "UE183", "사횡문", 4],
    [1438, "UE184", "지근", 4],
    [1439, "UE185", "소지중절", 4],
    [1440, "UE186", "사중봉", 4],
    [1441, "UE187", "육봉", 4],
    [1442, "UE188", "오경문", 4],
    [1443, "UE189", "단정", 4],
    [1444, "UE190", "구전풍", 4],
    [1445, "UE191", "풍관", 4],
    [1446, "UE192", "귀당", 4],
    [1447, "UE193", "대지절횡문", 4],
    [1448, "UE194", "풍안", 4],
    [1449, "UE195", "사전", 4],
    [1450, "UE196", "사봉", 4],
    [1451, "UE197", "십선", 4],
    [1452, "UE198", "소지첨", 4],
    [1453, "UE199", "귀신", 4],
    [1454, "UE200", "대무지두", 4],
    [1455, "UE201", "노룡", 4],
    [1456, "UE202", "지장", 4],
    [1457, "UE203", "심계점", 4],
    [1458, "UE204", "수팔장", 4],
    [1459, "UE205", "과점", 4],
    [1460, "UE206", "대장", 4],
    [1461, "UE207", "내중괴", 4],
    [1462, "UE208", "인중심", 4],
    [1463, "UE209", "심혈", 4],
    [1464, "UE210", "간혈", 4],
    [1465, "UE211", "폐혈", 4],
    [1466, "UE212", "명문[2]", 4],
    [1467, "UE213", "신혈", 4],
    [1468, "UE214", "부관", 4],
    [1469, "UE215", "외관", 4],
    [1470, "UE216", "대관", 4],
    [1471, "UE217", "중관", 4],
    [1472, "UE218", "소관", 4],
    [1473, "UE220", "흉혈", 4],
  ]

  /** 기본 Acupoint 인터페이스 형태로 변환된 데이터 */
  private static readonly defaultAcupoints: AcupointSerializer[] = AcupointConstants.rawData.map(
    ([acupointId, acupointCode, acupointName, acupointPartNo]) => ({
      acupointId,
      acupointCode,
      acupointName,
      acupointPartNo,
      countsPrivate: 0,
    })
  )

  /**
   * 서버 데이터 설정 (로그인 시 호출)
   * @param serverData 서버에서 받아온 경혈 데이터
   */
  static setServerData(serverData: AcupointSerializer[]): void {
    this.serverAcupoints = serverData
  }

  /**
   * 서버 데이터 초기화 (로그아웃 시 호출)
   */
  static clearServerData(): void {
    this.serverAcupoints = null
  }

  /**
   * 경혈 데이터 반환 (서버 데이터가 있으면 우선 사용, 없으면 기본값 사용)
   */
  static get acupoints(): AcupointSerializer[] {
    return this.serverAcupoints || this.defaultAcupoints
  }

  /**
   * 서버 데이터 사용 여부 확인
   */
  static get isUsingServerData(): boolean {
    return this.serverAcupoints !== null
  }

  /**
   * 데이터 소스 정보 반환
   */
  static get dataSource(): "server" | "default" {
    return this.serverAcupoints ? "server" : "default"
  }

  /**
   * 현재 상태 정보 반환 (디버깅용)
   */
  static getStatus(): {
    usingServerData: boolean
    dataSource: "server" | "default"
    totalCount: number
    serverDataCount: number
    defaultDataCount: number
  } {
    return {
      usingServerData: this.isUsingServerData,
      dataSource: this.dataSource,
      totalCount: this.acupoints.length,
      serverDataCount: this.serverAcupoints?.length || 0,
      defaultDataCount: this.defaultAcupoints.length,
    }
  }
}
